import { Box, Typography } from '@mui/material';
import { ChevronRight } from 'lucide-react';
import { HAIRLINE } from '../colors';
import useCashDiscount from '../../../../hooks/payments/useCashDiscount';
import { APPOINTMENTS_GRID_COLUMNS } from './tabTableLayout';
import {
  describeAppointmentRow,
  ProfileAppointment,
} from './helpers/appointmentRowContent';

interface Props {
  appointment: ProfileAppointment;
  timezone: string;
  now: Date;
  onSelect: (appointment: ProfileAppointment) => void;
}

function AppointmentTableRow({ appointment, timezone, now, onSelect }: Props) {
  const { getAllInPrice } = useCashDiscount();
  const content = describeAppointmentRow(
    appointment,
    timezone,
    now,
    getAllInPrice,
  );

  return (
    <Box
      onClick={() => onSelect(appointment)}
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: APPOINTMENTS_GRID_COLUMNS },
        columnGap: '24px',
        rowGap: { xs: '6px', sm: 0 },
        padding: '20px 0',
        borderBottom: `1px solid ${HAIRLINE}`,
        alignItems: 'baseline',
        cursor: 'pointer',
      }}>
      <Box>
        <Typography variant="h4" sx={{ color: 'text.primary' }}>
          {content.dateLabel}
        </Typography>
        <Box
          sx={{
            typography: content.statusVariant === 'danger' ? 'h5' : 'body2',
            marginTop: '4px',
            color:
              content.statusVariant === 'danger'
                ? 'primary.main'
                : 'text.tertiary',
          }}>
          {content.statusLine}
        </Box>
      </Box>
      <Typography variant="body1" sx={{ color: 'text.primary' }}>
        {content.serviceLabel}
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
        {content.artistLabel}
      </Typography>
      <Typography
        variant="h4"
        sx={{ color: 'text.primary', textAlign: { xs: 'left', sm: 'right' } }}>
        {content.valueLabel}
      </Typography>
      <Box sx={{ display: { xs: 'none', sm: 'flex' }, color: 'text.disabled' }}>
        <ChevronRight size={18} strokeWidth={2} color="currentColor" />
      </Box>
    </Box>
  );
}

export default AppointmentTableRow;
